import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
//icons
import { AiOutlineInfo } from 'react-icons/ai';
import { BsXLg } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { IoIosWarning } from 'react-icons/io';
//utils
import { capitalizeFirstLetter } from "utils/index";

const FeedbackStatus = ({ 
  feedbackType, 
  isVisible, 
  msgObject, 
  onClose 
}) => {
  const [showCard, setShowCard] = useState(isVisible);
  const { t } = useTranslation(['feedbackstatus']);

  useEffect(() => {
    setShowCard(isVisible);
  }, [isVisible]);

  const handleIconClose = () => {
    setShowCard(false);
  }

  const evaluateMsgObject = (value) => {
    if (typeof value === "string") {
      return <p className="mt-2 text-start">
        {capitalizeFirstLetter(value) || t('error')} 
        </p>
    } 
    if (typeof value === "object" && value !== null) {
      return Object.entries(value).map(([key, itemValue], i) => (
        <div key={i} className="mt-2 text-start">
          <strong>{capitalizeFirstLetter(key)}:</strong>
          {Array.isArray(itemValue) ? (
            itemValue.map((subItem, j) => (
              <p key={j} className="mt-1">
                {capitalizeFirstLetter(subItem)}
              </p>
            ))
          ) : (
            <p className="mt-1">{capitalizeFirstLetter(itemValue)}</p>
          )}
        </div>
      ));
    }
    return null
  }

  const translateStatus = (feedbackType) => {
    switch (feedbackType) {
      case 'success':
        return (
          <>
            <div className="icon-feedback success">
              <FaCheck size={20} color="#8da585" />
            </div>
            <p className="mt-2">{msgObject || t('success')}</p>
          </>
        );
      case 'warning':
        return (
          <>
            <div className="icon-feedback warning">
              <IoIosWarning size={20} color="#98712d" />
            </div>
            <p className="mt-2">{msgObject || t('warning')}</p>
          </>
        );
      case 'error':
        return (
          <>
            <div className="icon-feedback error">
              <BsXLg size={20} color="#b23028" />
            </div>
            <p className="d-flex flex-column align-items-start mt-2">{evaluateMsgObject(msgObject)}</p>
          </>
        );
      case 'info':
        return (
          <>
            <div className="icon-feedback info">
              <AiOutlineInfo size={20} color="#437fad" />
            </div>
            <p className="mt-2">{msgObject || t('info')}</p>
          </>
        );
      default:
        return null;
    }
  };
  

  return (
    showCard && (
      <Col md={8} lg={8} xs={11} className={` mb-3 p-4 card-feedback d-flex position-relative ${feedbackType}`}>
        <div className="d-flex">
          <div className="feedback">{translateStatus(feedbackType)}</div>
          <div className="container-icon">
            <BsXLg 
              color="gray" size={18} 
              onClick={onClose || handleIconClose} 
              className="close-feedback" 
            />
          </div>
        </div>
      </Col>
    )
  );
};

FeedbackStatus.propTypes = {
  msgObject: PropTypes.string || PropTypes.object,
  feedbackType: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default FeedbackStatus;
